import * as http from 'reporting-data/request/http';
import { FEEDBACK_TYPE, REPORTING_USER_FEEDBACK_URL } from '../../singleReportViewer/fullPage/report-ai-assistant-insights/utils';
import I18n from 'I18n';
export const sendReportingInsightsUserFeedbackForReportingBackend = ({
  report,
  insight,
  dataset,
  feedbackValue,
  correlationId,
  contactForMoreFeedback = false,
  userFeedback = ''
}) => {
  if (report && dataset) {
    const verificationResult = insight.verificationResult;
    if (feedbackValue) {
      if (verificationResult) {
        return http.post(REPORTING_USER_FEEDBACK_URL, {
          data: {
            userFeedback,
            contactForMoreFeedback,
            reportEgg: report.toJS(),
            feedback: [{
              correlationId: insight.correlationId,
              insightValue: verificationResult.toString(),
              feedbackValue: true,
              feedbackType: FEEDBACK_TYPE.VERIFICATION
            }, {
              correlationId,
              insightValue: insight.value,
              feedbackValue: true,
              feedbackType: FEEDBACK_TYPE.INSIGHTS
            }],
            dataSetsForInsights: dataset.toJS()
          }
        });
      } else {
        return http.post(REPORTING_USER_FEEDBACK_URL, {
          data: {
            userFeedback,
            contactForMoreFeedback,
            reportEgg: report.toJS(),
            feedback: [{
              correlationId: insight.correlationId,
              insightValue: verificationResult.toString(),
              feedbackValue: false,
              feedbackType: FEEDBACK_TYPE.VERIFICATION
            }, {
              correlationId,
              insightValue: insight.value,
              feedbackValue: true,
              feedbackType: FEEDBACK_TYPE.INSIGHTS
            }],
            dataSetsForInsights: dataset.toJS()
          }
        });
      }
    } else {
      if (!userFeedback) {
        return http.post(REPORTING_USER_FEEDBACK_URL, {
          data: {
            userFeedback: '',
            contactForMoreFeedback,
            reportEgg: report.toJS(),
            feedback: [{
              correlationId,
              insightValue: insight.value,
              feedbackValue: false,
              feedbackType: FEEDBACK_TYPE.INSIGHTS
            }],
            dataSetsForInsights: dataset.toJS()
          }
        });
      } else {
        let insightsVerifyShouldRejectResult;
        if (I18n.text('reporting-enablement.platformReport.reportVisualizationInsights.feedback.negative.options.inaccurate') === userFeedback) {
          insightsVerifyShouldRejectResult = insight.verificationResult;
        } else {
          insightsVerifyShouldRejectResult = !insight.verificationResult;
        }
        if (insightsVerifyShouldRejectResult) {
          http.post(REPORTING_USER_FEEDBACK_URL, {
            data: {
              userFeedback,
              contactForMoreFeedback,
              reportEgg: report.toJS(),
              feedback: [{
                correlationId,
                insightValue: insight.value,
                feedbackValue: false,
                feedbackType: FEEDBACK_TYPE.INSIGHTS
              }, {
                correlationId: insight.correlationId,
                insightValue: insight.verificationResult.toString(),
                feedbackValue: false,
                feedbackType: FEEDBACK_TYPE.VERIFICATION
              }],
              dataSetsForInsights: dataset.toJS()
            }
          });
        } else {
          http.post(REPORTING_USER_FEEDBACK_URL, {
            data: {
              userFeedback,
              contactForMoreFeedback,
              reportEgg: report.toJS(),
              feedback: [{
                correlationId,
                insightValue: insight.value,
                feedbackValue: false,
                feedbackType: FEEDBACK_TYPE.INSIGHTS
              }, {
                correlationId: insight.correlationId,
                insightValue: insight.verificationResult.toString(),
                feedbackValue: true,
                feedbackType: FEEDBACK_TYPE.VERIFICATION
              }],
              dataSetsForInsights: dataset.toJS()
            }
          });
        }
      }
    }
  }
};